export default __webpack_public_path__ + "b97ca4d10df872af7d5b137ae195d94c.png";